import { ButtonWithDialog } from "@focus/focusUI";
import { useMemo, useState } from "react";
import { usePhonebook } from "../../hooks/usePhonebook";
import { ROLES, useRoles } from "../../hooks/useRoles";
import type { Contact } from "../../types/phonebook";
import { PhonebookContactForm } from "./PhonebookContactForm";
import { useMe } from "../../hooks/useMe";

export const EditContactButton = ({
  contact,
  disabled,
}: {
  contact: Contact;
  disabled?: boolean;
}) => {
  const me = useMe();
  const { updateContact } = usePhonebook();

  const { roles } = useRoles();
  const [isInvalid, setIsInvalid] = useState(true);

  const canEdit = useMemo(() => {
    if (roles.includes(ROLES.ADMIN)) return true;
    if (!roles.includes(ROLES.ORG_ADMIN)) return false;

    return (
      contact?.organizations?.some((org) => me?.organizations?.includes(org)) ?? false
    );
  }, [roles, me?.organizations, contact?.organizations]);

  const handleAccept = (updated: Contact) => {
    if (canEdit) {
      updateContact(updated);
    }
  };

  return (
    <ButtonWithDialog<Contact>
      icon={canEdit ? "edit" : "eye-open"}
      minimal
      intent="none"
      defaultContent={contact}
      onAccept={handleAccept}
      disableAccept={canEdit && isInvalid}
      hideButtons={!canEdit}
      headerTitle={canEdit ? "Edit Contact" : "Contact Info"}
      form={({ content, onUpdate }) => (
        <PhonebookContactForm
          content={content}
          onUpdate={onUpdate}
          onValidityChange={(valid) => setIsInvalid(!valid)}
          readOnly={!canEdit}
        />
      )}
      disabled={disabled}
    />
  );
};
